const parsePoint = (point, fixedPoints = 7, returnPoint = false) => {
  if (point && !isNaN(point)) return parseFloat(point)?.toFixed(fixedPoints);
  if (returnPoint) return point;
  return '--';
};

export default parsePoint;
